<template>
    <div>
        <div class="row ml-0">
            <div>
                <v-radio-group v-model="doorMeasureSelection" row>
                    <template v-if="getCharacteristicAndValues('CUST_MM_TUERMASS').values.length > 10">
                        <v-row>
                            <v-col cols="6" class="pb-2"
                                   v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUERMASS').values"
                                   :key="index">
                                <v-radio :label="valueDefinition.description" :value="valueDefinition.value"
                                         @change="addCharacterisitc(getCharacteristicAndValues('CUST_MM_TUERMASS'), valueDefinition);changeSelectedWidth(valueDefinition.value)">
                                </v-radio>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-radio class="pb-2"
                                 v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUERMASS').values"
                                 :key="index" :label="valueDefinition.description" :value="valueDefinition.value"
                                 @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_TUERMASS'), valueDefinition: valueDefinition });changeSelectedWidth(valueDefinition.value)">
                        </v-radio>
                    </template>
                </v-radio-group>
            </div>
            <div v-if="isDoorCertified()" class="mt-5 ml-10">
                <span class="red--text">{{$t('doorIsNotCertified')}}</span>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col-4">
                    <div>
                        <div class="body-2 pb-2" style="">
                            {{ getCharacteristicAndValues(returnSelectedWidthCharacteristics[0]).description }}</div>
                        <v-text-field v-model="getDoorMeasure.width" class="unit-text-field"
                                      @change="valueAddCharacteristic({ characteristicValue: getCharacteristicAndValues(returnSelectedWidthCharacteristics[0]), value: getDoorMeasure.width });"
                                      dense outlined hide-details value="100" suffix="mm">
                        </v-text-field>
                    </div>
                </div>
                <div class="col-4">
                    <div class="body-2 pb-2" style="">
                        {{ getCharacteristicAndValues(returnSelectedWidthCharacteristics[1]).description }}</div>
                    <v-text-field v-model="getDoorMeasure.heightBS" class="unit-text-field"
                        @change="valueAddCharacteristic({ characteristicValue: getCharacteristicAndValues(returnSelectedWidthCharacteristics[1]), value: getDoorMeasure.heightBS });"
                        dense outlined hide-details value="100" suffix="mm">
                    </v-text-field>
                </div>
                <div class="col-4">
                    <div class="body-2 pb-2" style="">
                        {{ getCharacteristicAndValues(returnSelectedWidthCharacteristics[2]).description }}</div>
                    <v-text-field v-model="getDoorMeasure.heightGBS" class="unit-text-field"
                                  @change="valueAddCharacteristic({ characteristicValue: getCharacteristicAndValues(returnSelectedWidthCharacteristics[2]), value: getDoorMeasure.heightGBS });"
                                  dense outlined hide-details value="100" suffix="mm">
                    </v-text-field>
                </div>
            </div>
        </div>

        <div class="data-table mb-6">
            <div class="d-flex pb-4">
                <div class="custom-col pa-2" style="width:50%">
                    <div class="body-2 font-weight-bold black--text">
                        {{$t('turstocklichteBandseite')}}
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('breite')}} [STLB]:
                        <span class="black--text float-right"
                            :class="{'green--text' : selectedWidth === 'FF'}">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_STLB', context).value.value) }}mm</span>
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('hohe')}} [BSTLH]:
                        <span class="black--text float-right"
                            :class="{'green--text' : selectedWidth === 'FF'}">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BSTLH', context).value.value) }}
                            mm</span>
                    </div>
                </div>
                <div class="custom-col pa-2" style="width:50%">
                    <div class="body-2 font-weight-bold black--text">
                        {{$t('turstocklichteGegenbandseite')}}
                    </div>
                    <div class="body-2 lighter-text mt-5">
                        {{$t('hohe')}} [GBSTLH]:
                        <span class="black--text float-right"
                            :class="{'green--text' : selectedWidth === 'FF'}">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', context).value.value) }}
                            mm</span>
                    </div>
                </div>
            </div>
            <div class="d-flex pb-4">
                <div class="custom-col pa-2" style="width:50%">
                    <div class="body-2 font-weight-bold black--text">
                        {{$t('durchgangslichteBandseite')}}
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('dlbBie90')}}:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_DLB_90', context).value.value) }}
                            mm</span>
                    </div>

                    <div class="body-2 lighter-text">
                        {{$t('bdlh')}}:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BDLH', context).value.value) }}
                            mm</span>
                    </div>
                </div>
                <div class="custom-col pa-2" style="width:50%">
                    <div class="body-2 font-weight-bold black--text">
                        {{$t('durchgangslichteGegenBandseite')}}
                    </div>
                    <div class="body-2 lighter-text mt-5">
                        {{$t('hohe')}} [GBDLH]:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_GBDLH', context).value.value) }}
                            mm</span>
                    </div>
                </div>
            </div>
            <div class="d-flex pb-4">
                <div class="custom-col pa-2" style="width:50%">

                    <div class="body-2 font-weight-bold black--text">
                        {{$t('mauerlichteBandseite')}}
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('breite')}} [MLB]:
                        <span class="black--text float-right"
                            :class="{'green--text' : selectedWidth === 'WW'}">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_MLB', context).value.value) }}
                            mm</span>
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('hohe')}} [BMLH]:
                        <span class="black--text float-right"
                            :class="{'green--text' : selectedWidth === 'WW'}">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BMLH', context).value.value) }}
                            mm</span>
                    </div>

                </div>
                <div class="custom-col pa-2" style="width:50%">
                    <div class="body-2 font-weight-bold black--text">
                        {{$t('mauerlichteGegenbandseite')}}
                    </div>
                    <div class="body-2 lighter-text mt-5">
                        {{$t('hohe')}} [GBMLH]:
                        <span class="black--text float-right"
                            :class="{'green--text' : selectedWidth === 'WW'}">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_GBMLH', context).value.value) }}
                            mm</span>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <div class="custom-col pa-2" style="width:50%">

                    <div class="body-2 font-weight-bold black--text">
                        {{$t('turstockmassBandseite')}}
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('breite')}} [BSTMB]:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BSTMB', context).value.value) }}
                            mm</span>
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('hohe')}} [BSTMH]:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BSTMH', context).value.value) }}
                            mm</span>
                    </div>

                </div>
                <div class="custom-col pa-2" style="width:50%">

                    <div class="body-2 font-weight-bold black--text">
                        {{$t('turstockmassGegenBandseite')}}
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('breite')}} [GBSTMB]:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_GBSTMB', context).value.value) }}
                            mm</span>
                    </div>
                    <div class="body-2 lighter-text">
                        {{$t('hohe')}} [GBSTMH]:
                        <span
                            class="black--text float-right">{{ parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_GBSTMH', context).value.value) }}
                            mm</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-6">
            <div>
                <div class="body-2 pb-2" style=""><span class="font-weight-bold" style="font-size: 1.5em;">{{getRegisteredCharacteristicsValue('KTU_MM_NIVEAU_ART', context).value.value}}</span> {{ getNiveauArtLabel }} </div>
                <v-text-field class="unit-text-field" disabled style="" :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_NIVEAU_HOEHE', context).value.value)" dense outlined hide-details  suffix="mm">
                </v-text-field>
            </div>
        </div>

        <div class="mb-4">
            <div class="font-weight-bold mb-3">{{$t('zertifizierterBereichStoclichte')}}</div>
            <div class="d-flex mb-5">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('minimaleSTLB')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.minSTLB" suffix="mm">
                    </v-text-field>
                </div>
                <div class="" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('maximaleSTLB')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.maxSTLB" suffix="mm">
                    </v-text-field>
                </div>
            </div>
            <div class="d-flex">
                <div class="mr-4" style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('minimaleSTHL')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.minSTLH" suffix="mm">
                    </v-text-field>
                </div>
                <div style="width:50%;">
                    <div class="body-2 pb-2" style="">{{$t('maximaleSTHL')}}</div>
                    <v-text-field class="unit-text-field" disabled style="" dense outlined hide-details :value="doorLeafSizesData.maxSTLH+doorLeafSizesData.maxUpperPanelHeight" suffix="mm">
                    </v-text-field>
                </div>
            </div>
        </div>

    </div>

    <!-- <div>
        <h1 class="title">Auswahl</h1>
        <div class="input-group">
            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">               

                <label v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_TUERMASS').values" :key="index" 
                @click="addCharacterisitc({ characteristic: getCharacteristicAndValues('CUST_MM_TUERMASS'), valueDefinition: valueDefinition });changeSelectedWidth(valueDefinition.value)" 
                :class="{ 'btn':true, 'btn-secondary':true, 'active': checkRadioValue(getCharacteristicAndValues('CUST_MM_TUERMASS').code, valueDefinition.value) }">
                    <div class="radio-btn">
                        <span></span>
                    </div>
                    <input type="radio" :name="valueDefinition.value" :value="selectedWidth" autocomplete="off"> {{ valueDefinition.description }}
                </label>
                
            </div>
        </div>
        <div class="input-group">
            <div class="input-group-prepend">
                
                <span class="input-group-text" id="inputGroup-sizing-default">{{ getCharacteristicAndValues(returnSelectedWidthCharacteristics[0]).description }}</span>
            </div>
            <input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"
                v-model="getDoorMeasure.width"
                @change="valueAddCharacteristic({ characteristicValue: getCharacteristicAndValues(returnSelectedWidthCharacteristics[0]), value: getDoorMeasure.width });"
                >
            <span class="post">mm</span>
        </div>
        <div class="input-group">
            <div class="input-group-prepend">
                
                <span class="input-group-text" id="inputGroup-sizing-default">{{ getCharacteristicAndValues(returnSelectedWidthCharacteristics[1]).description }}</span>
            </div>
            <input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"
                v-model="getDoorMeasure.heightBS"
                @change="valueAddCharacteristic({ characteristicValue: getCharacteristicAndValues(returnSelectedWidthCharacteristics[1]), value: getDoorMeasure.heightBS });"
                >
            <span class="post">mm</span>
        </div>
        <div class="input-group">
            <div class="input-group-prepend">
                
                <span class="input-group-text" id="inputGroup-sizing-default">{{ getCharacteristicAndValues(returnSelectedWidthCharacteristics[2]).description }}</span>
            </div>
            <input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"
                v-model="getDoorMeasure.heightGBS"
                @change="valueAddCharacteristic({ characteristicValue: getCharacteristicAndValues(returnSelectedWidthCharacteristics[2]), value: getDoorMeasure.heightGBS });"
                >
            <span class="post">mm</span>
        </div>
        <div class="measure-wrapper">
            <div class="measure-list">
                <div class="measure-item">
                    <p class="title">Turstocklichte Bandseite</p>
                    <p>Breite [STLB]:
                        <span :class="{'green' : selectedWidth === 'FF'}">{{ Number(getRegisteredCharacteristicsValue('KTU_MM_STLB', context).value.value) }} mm</span>
                    </p>
                    <p>Höhe [BSTLH]:
                        <span :class="{'green' : selectedWidth === 'FF'}">{{ Number(getRegisteredCharacteristicsValue('KTU_MM_BSTLH', context).value.value) }} mm</span>
                    </p>
                </div>
                <div class="measure-item">
                    <p class="title">Turstocklichte Gegenbandseite</p>
                    <p>Höhe [GBSTLH]:
                        <span :class="{'green' : selectedWidth === 'FF'}">{{ Number(getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', context).value.value) }} mm</span>
                    </p>
                </div>
            </div>
            <div class="measure-list">
                <div class="measure-item">
                    <p class="title">Durchgangslichte bei 90° Bandseite</p>
                    <p>Breite [DLB bie 90°]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_DLB_90', context).value.value }} mm</span>
                    </p>
                    <p>Höhe [BDLH]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_BDLH', context).value.value }} mm</span>
                    </p>
                </div>
                <div class="measure-item">
                    <p class="title">Durchgangslichte Gegenbandseite</p>
                    <p>Höhe [GBDLH]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_GBDLH', context).value.value }} mm</span>
                    </p>
                </div>
            </div>
            <div class="measure-list">
                <div class="measure-item">
                    <p class="title">Mauerlichte Bandseite</p>
                    <p>Breite [MLB]:
                        
                        <span class="" :class="{'green' : selectedWidth === 'WW'}">{{ Number(getRegisteredCharacteristicsValue('KTU_MM_MLB', context).value.value) }} mm</span>
                    </p>
                    <p>Höhe [BMLH]:
                        <span class="" :class="{'green' : selectedWidth === 'WW'}">{{ Number(getRegisteredCharacteristicsValue('KTU_MM_BMLH', context).value.value) }} mm</span>
                    </p>
                </div>
                <div class="measure-item">
                    <p class="title">Mauerlichte Gegenbandseite</p>
                    <p>Höhe [GBMLH]:
                        <span class="" :class="{'green' : selectedWidth === 'WW'}">{{ Number(getRegisteredCharacteristicsValue('KTU_MM_GBMLH', context).value.value) }} mm</span>
                    </p>
                </div>
            </div>
            <div class="measure-list">
                <div class="measure-item">
                    <p class="title">Turstockmass Bandseite</p>
                    <p>Breite [BSTMB]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_BSTMB', context).value.value }} mm</span>
                    </p>
                    <p>Höhe [BSTMH]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_BSTMH', context).value.value }} mm</span>
                    </p>
                </div>
                <div class="measure-item">
                    <p class="title">Turstockmass Gegenbandseite</p>
                    <p>Höhe [GBSTMB]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_GBSTMB', context).value.value }} mm</span>
                    </p>
                    <p>Höhe [GBSTMH]:
                        <span>{{ getRegisteredCharacteristicsValue('KTU_MM_GBSTMH', context).value.value }} mm</span>
                    </p>
                </div>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                   
                    <span class="input-group-text" id="inputGroup-sizing-default">{{ getRegisteredCharacteristicsValue('KTU_MM_NIVEAU_ART', context).value.description }}</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" :value="getRegisteredCharacteristicsValue('KTU_MM_NIVEAU_HOEHE', context).value.value">
                <span class="post">mm</span>
            </div>
        </div>

        <label class="input-label margin-top">Zertifizierter Bereich Stoclichte</label>
        <div class="disabled-inputs">
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Minimale STLB</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="1060">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Maximale STLB</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="1950">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Minimale STHL</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="1950">
                <span class="post">mm</span>
            </div>
            <div class="input-group disabled">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Maximale STHL</span>
                </div>
                <input type="text" class="form-control" aria-label="Default" disabled
                    aria-describedby="inputGroup-sizing-default" value="3080">
                <span class="post">mm</span>
            </div>
        </div>
    </div> -->
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../../configurator/DoorConfiguration';
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../../services/ParserService';

    export default Vue.extend({
        name: 'DoorWidth',
        props: {
            doorLeafSizesData: Object
        },
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                context: DoorConfiguration.Measure,
                widthWallToWall: ['KTU_MM_MLB', 'KTU_MM_BMLH', 'KTU_MM_GBMLH'],
                widthFrameToFrame: ['KTU_MM_STLB', 'KTU_MM_BSTLH', 'KTU_MM_GBSTLH'],
                selectedWidth: 'WW'
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration',
                'getRegisteredCharacteristicsValue'
            ]),
            ...mapGetters('measureModule', ['getCharacteristicAndValues', 'getNrOfValuesByCharacteristic',
                'checkRadioValue', 'getDoorMeasure'
            ]),
            returnSelectedWidthCharacteristics() {
                const _this = this;
                let selectedMeasurements = [];
                if (this.selectedWidth === 'FF') {
                    selectedMeasurements = this.widthFrameToFrame;
                } else {
                    selectedMeasurements = this.widthWallToWall;
                }

                _this.valueAddCharacteristic({
                    characteristicValue: _this.getCharacteristicAndValues(selectedMeasurements[0]),
                    value: _this.getDoorMeasure.width
                });
                _this.valueAddCharacteristic({
                    characteristicValue: _this.getCharacteristicAndValues(selectedMeasurements[1]),
                    value: _this.getDoorMeasure.heightBS
                });
                _this.valueAddCharacteristic({
                    characteristicValue: _this.getCharacteristicAndValues(selectedMeasurements[2]),
                    value: _this.getDoorMeasure.heightGBS
                });

                return selectedMeasurements;
            },
            doorMeasureSelection: function () {
                return this.getRegisteredCharacteristicsValue('CUST_MM_TUERMASS', this.context).value.value;
            },
            getNiveauArtLabel(){
                const char = this.getRegisteredCharacteristicsValue('KTU_MM_NIVEAU_ART', this.context).value.value;
                switch(char){
                    case "A":
                        return this.$t('niveauArtALabel');
                    case "B":
                        return this.$t('niveauArtBLabel');
                    case "C":
                        return this.$t('niveauArtCLabel');
                    default:
                        return "";
                }

            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration']),
            ...mapActions('measureModule', ['addCharacterisitc', 'valueAddCharacteristic',
                'checkBoxAddCharacteristic', 'setDoorMeasure'
            ]),
            changeSelectedWidth(width) {
                debugger;
                this.selectedWidth = width;
            },
            isDoorCertified: function () {
                if(!this.minValue(this.getRegisteredCharacteristicsValue('KTU_MM_STLB', this.context).value.value, this.doorLeafSizesData.minSTLB)){
                    return true;
                }
                else if(!this.maxValue(this.getRegisteredCharacteristicsValue('KTU_MM_STLB', this.context).value.value, this.doorLeafSizesData.maxSTLB)) {
                    return true;
                }
                else if(!this.minValue(this.getRegisteredCharacteristicsValue('KTU_MM_BSTLH', this.context).value.value, this.doorLeafSizesData.minSTLH)) {
                    return true;
                }
                else if(!this.maxValue(this.getRegisteredCharacteristicsValue('KTU_MM_BSTLH', this.context).value.value, this.doorLeafSizesData.maxSTLH + this.doorLeafSizesData.maxUpperPanelHeight)) {
                    return true;
                }
                else if(!this.minValue(this.getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', this.context).value.value, this.doorLeafSizesData.minSTLH)) {
                    return true;
                }
                else return !this.maxValue(this.getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', this.context).value.value, this.doorLeafSizesData.maxSTLH + this.doorLeafSizesData.maxUpperPanelHeight);
            },
            minValue(value,min) {
                return (value || "") >= min || false;
            },
            maxValue(value,max) {
                return (value || "") <= max || false;
            },
            setInitialState() {
                const _this = this;
                const doorMeasure = _this.getDoorMeasure;
                if (this.doorMeasureSelection !== '0' && this.doorMeasureSelection === 'WW') {
                    doorMeasure.width = _this.getRegisteredCharacteristicsValue('KTU_MM_MLB', this.context)
                        .value.value;
                    doorMeasure.heightBS = _this.getRegisteredCharacteristicsValue('KTU_MM_BMLH', this.context)
                        .value.value;
                    doorMeasure.heightGBS = _this.getRegisteredCharacteristicsValue('KTU_MM_GBMLH', this
                        .context).value.value;
                    _this.setDoorMeasure(doorMeasure);
                } else if (this.doorMeasureSelection !== '0' && this.doorMeasureSelection === 'FF') {
                    doorMeasure.width = _this.getRegisteredCharacteristicsValue('KTU_MM_STLB', this.context)
                        .value.value;
                    doorMeasure.heightBS = _this.getRegisteredCharacteristicsValue('KTU_MM_BSTLH', this.context)
                        .value.value;
                    doorMeasure.heightGBS = _this.getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', this
                        .context).value.value;
                    _this.setDoorMeasure(doorMeasure);
                }

                this.selectedWidth = this.doorMeasureSelection;
                // this.selectedWidth = this.doorMeasureSelection !== '0' ? this.doorMeasureSelection : this.selectedWidth;
            },
        },
        mounted() {
            this.setInitialState();
            // this.$store.dispatch('measureModule/setDoorWidthMeasurements');
        },
    });
</script>
<style lang="scss" scoped>
    .d-flex {
        .custom-col {
            border: 1px solid #e4e4e4;
        }
    }

    .lighter-text {
        color: #656565;
    }
</style>